import { GET_USER_REQUEST, GET_USER_SUCCESS, GET_USER_FAILURE } from '../actions/getUser';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

export default function getUserReducer(state = initialState, action) {
  switch (action.type) {
    case GET_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_USER_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case GET_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}